import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=6880c67e&"
import script from "./notice.vue?vue&type=script&lang=js&"
export * from "./notice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6880c67e')) {
      api.createRecord('6880c67e', component.options)
    } else {
      api.reload('6880c67e', component.options)
    }
    module.hot.accept("./notice.vue?vue&type=template&id=6880c67e&", function () {
      api.rerender('6880c67e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/notice/notice.vue"
export default component.exports